<template>
  <div>
    <smart-icon
      icon="icon-blood-pressure"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'BLOOD_PRESSURE'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-heart-outline"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'ANGINA'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-heart-outline"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'HEART_RATE'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-glucose"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'GLUCOSE'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-glucose"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'HBA1C'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-weight"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'WEIGHT'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-cholesterol-hdl"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'HDL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-cholesterol-ldl"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'LDL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="icon-cholesterol-total"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'TOTAL_CHOLESTEROL'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-heart-outline"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'HEART_RHYTHM'"
      v-bind="$attrs"
    />
    <smart-icon
      icon="mdi-smoking-off"
      :size="$attrs.size || 20"
      :iconColor="$attrs.iconColor||$color.coro.gray"
      v-if="categoryKey.toUpperCase() === 'SMOKING'"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import SmartIcon from "./SmartIcon";

/**
 * Component RelatedPartsIcon.vue
 *
 * @module RelatedPartsIcon
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/APP_DASHBOARD/templates/components/Parts/RelatedPartsIcon.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "RelatedPartsIcon",
  components: { SmartIcon },
  props: {
    categoryKey: {
      type: String,
      default: () => "blood_pressure",
    },
  },
};
</script>